import React, { useState, useEffect, useRef } from 'react';
import './EnrolNow.css';
import './BookTrail.css';
import { areas } from '../Centers/areas';
import axios from "axios";
import Swal from 'sweetalert2';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from "react-router-dom";
const BookTrial = () => {
  const [userName, setUserName] = useState('');
  const [selectedCourtId, setSelectedCourtId] = useState([]);
  const [selectedCourtTimingId, setSelectedCourtTimingId] = useState([]);
  const [email, setEmail] = useState('');
  const [isCreatingNewChild, setIsCreatingNewChild] = useState(false);
  const [selectedChildId, setSelectedChildId] = useState(null);
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const [showCreateChildInput, setShowCreateChildInput] = useState(false);
  const [newChildName, setNewChildName] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [showAreaDropdown, setShowAreaDropdown] = useState(false);
  const [selectedCenter, setSelectedCenter] = useState('');
  const [trialTimes, setTrialTimes] = useState([]);
  const [showCenterDropdown, setShowCenterDropdown] = useState(false);
  const [showChildDropdown, setShowChildDropdown] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const dropdownRef = useRef(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const selectWrapperRef = useRef(null);
  const childDropdownRef = useRef(null);
  const [centers, setCenters] = useState([]);
  const navigate = useNavigate();
  const [selectedTrialDate, setSelectedTrialDate] = useState('');
  const [selectedTrialTime, setSelectedTrialTime] = useState('');
  const [trialDates, setTrialDates] = useState([]);


  const [errorMessages, setErrorMessages] = useState({
    userName: '',
    contactNumber: '',
    selectedArea: '',
    selectedCenter: '',
    selectedTrialTime: '',
    otp: '',
    child: '',
    email: '',
    userCategory: '',
    proficiencyLevel: '',
  });
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };
  const areaDropdownRef = useRef(null);
  const centerDropdownRef = useRef(null);
  const [userDetails, setUserDetails] = useState(null);
  const [parentId, setParentId] = useState(null);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);
  const [userCategory, setUserCategory] = useState('Adult'); // Default to Adult
  const [proficiencyLevel, setProficiencyLevel] = useState('');
  const handleCategoryChange = (category) => {
    setUserCategory(category);
    setErrorMessages((prevErrors) => ({ ...prevErrors, userCategory: '' })); // Clear error
  };

  const handleProficiencyChange = (level) => {
    setProficiencyLevel(level);
    setErrorMessages((prevErrors) => ({ ...prevErrors, proficiencyLevel: '' })); // Clear error
  };
  useEffect(() => {
    // Reset selected date and time slot when category changes
    setSelectedTrialDate('');
    setSelectedTrialTime('');
    setAvailableSlots([]); // Clear available slots
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedTrialDate: '',
      selectedTrialTime: '',
    }));
  }, [userCategory]);

  useEffect(() => {
    // Reset selected date and time slot when proficiency level changes
    setSelectedTrialDate('');
    setSelectedTrialTime('');
    setAvailableSlots([]); // Clear available slots
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedTrialDate: '',
      selectedTrialTime: '',
    }));
  }, [proficiencyLevel]);

  useEffect(() => {
    if (contactNumber) {
      setIsOtpVerified(false);
      setOtp('');
      setUserName('');
      setUserDetails(null);
      setShowOtpInput(false);
      setIsNewUser(false);
      setErrorMessages({
        userName: '',
        contactNumber: '',
        selectedArea: '',
        selectedCenter: '',
        selectedTrialTime: '',
        otp: '',
        child: '',
        email: '',
        userCategory: '',
        proficiencyLevel: '',
      });
    }
  }, [contactNumber]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (areaDropdownRef.current && !areaDropdownRef.current.contains(event.target)) {
        setShowAreaDropdown(false);
      }
      if (centerDropdownRef.current && !centerDropdownRef.current.contains(event.target)) {
        setShowCenterDropdown(false);
      }
      if (childDropdownRef.current && !childDropdownRef.current.contains(event.target)) {
        setShowChildDropdown(false);
        setShowCreateChildInput(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const fetchSportsCenters = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_API_URL_CENTER, {
        method: 'GET', // Adjust method if needed
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_KEY,
        }
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch sports centers.');
      }

      const centersData = Object.values(data.sportsToAcademiesMap.Swimming).flat();
      setCenters(centersData.map(center => ({
        id: center.id,
        name: center.name,
        latitude: center.latitude,
        longitude: center.longitude,
      })));
    } catch (error) {
      console.error('Error fetching data:', error);
      showBackendError(error);
    }
  };

  useEffect(() => {
    fetchSportsCenters();
  }, []);


  useEffect(() => {

  }, [selectedChildId]);


  const handleAreaChange = (areaName) => {
    setSelectedArea(areaName);
    setSelectedCenter('');
    setSelectedTrialDate('')
    setSelectedTrialTime('');
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedArea: '',
      selectedCenter: '',
      selectedTrialDate: '',
      selectedTrialTime: ''
    }));
    setShowAreaDropdown(false);
  };

  const handleCenterChange = (centerName) => {
    const selectedCenterData = centers.find(center => center.name === centerName);
    setSelectedCenter(centerName);
    setSelectedTrialTime('');
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedCenter: '',
      selectedTrialTime: ''
    }));
    setShowCenterDropdown(false);

  };

  const fetchUserDetails = async (mobileNumber) => {
    try {
      const formattedMobileNumber = mobileNumber.startsWith('+91') ? mobileNumber : '+91' + mobileNumber;
      const response = await fetch(process.env.REACT_APP_API_URL_FETCH_USER, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({ mobileNumber: formattedMobileNumber }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch user details.');
      }
      if (data && data.userDetails.success) {
        setUserDetails(data.userDetails);
        setIsNewUser(false);
        const parentId = data.userDetails.parent.id;
        const parentName = data.userDetails.parent.name;
        setParentId(parentId);
        setUserName(parentName);
      } else {
        setUserDetails(null);
        setIsNewUser(true);
        setParentId(null);
      }
    } catch (error) {
      setIsNewUser(true);
      setParentId(null);
      console.error("Error fetching user details:", error);
    }
  };



  const handleOptionSelect = (id) => {
    setSelectedCenter(id);
    setShowCenterDropdown(false);
  };
  const handleChildSelect = (child) => {

    if (child.isParent) {
  
      setUserName(child.name); // Set parent name
      setSelectedChildId(null); // No child ID for parent
      setIsCreatingNewChild(false); // Not creating a new child
    } else {

      setUserName(child.name); // Set child name
      setSelectedChildId(child.id); // Set child ID
      setIsCreatingNewChild(false);
    }
    setErrorMessages((prevErrors) => ({ ...prevErrors, child: '' })); // Clear child error
    setShowChildDropdown(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form fields
    let errors = {
      userName: !userName.trim() ? 'Name is required' : '',
      contactNumber: !contactNumber.trim() || !isContactNumberValid ? 'Please enter a valid contact number' : '',
      selectedArea: !selectedArea ? 'Please select an area' : '',
      selectedCenter: !selectedCenter ? 'Please select a center' : '',
      selectedTrialDate: !selectedTrialDate ? 'Please select a date' : '',
      selectedTrialTime: !selectedTrialTime ? 'Please select a trial time' : '',
      otp: !isOtpVerified ? 'Please verify OTP before submitting' : '',
      child: !userName.trim() ? 'Please select or create a child' : '',
      email: !email.trim() ? 'Email is required' : !validateEmail(email) ? 'Please enter a valid email' : '',
      userCategory: !userCategory.trim() ? 'Please select a Category' : '', // Validate userCategory
      proficiencyLevel: !proficiencyLevel.trim() ? 'Please select a Proficiency Level' : '', // Validate proficiencyLevel
    };

    const hasErrors = Object.values(errors).some((error) => error !== '');

    if (hasErrors) {
      setErrorMessages(errors);
      return;
    }

    try {
      const bookingData = {
        userName,
        contactNumber,
        selectedArea,
        selectedCenter,
        selectedTrialDate: formatDate(selectedTrialDate), // Format the date
        selectedTrialTime,
        selectedChildId,
      };

      setFormData(bookingData);
      setShowConfirmationModal(true);
    } catch (error) {
      console.error('Error during form submission:', error);
      setErrorMessages({ api: 'Failed to process the booking' });
      showBackendError(error);
    }
  };

  const handleOtpVerification = async () => {
    try {
      const formattedContactNumber = contactNumber.startsWith('+91') ? contactNumber : `+91${contactNumber}`;
      const response = await axios.post(process.env.REACT_APP_API_URL_OTP_VERIFY, {
        data: {
          phone_number: formattedContactNumber,
          has_firebase_check: false,
          otp: otp,
        },
      });

      if (response.data.success) {
        setIsOtpVerified(true);

      } else {
        setErrorMessages((prevErrors) => ({
          ...prevErrors,
          otp: response.data.message || 'Invalid OTP, please try again',
        }));
        Swal.fire({
          icon: 'error',
          title: 'Invalid OTP',
          text: response.data.message || 'The OTP you entered is invalid. Please try again.',
        });
      }
    } catch (error) {
      setErrorMessages((prevErrors) => ({
        ...prevErrors,
        otp: 'Failed to verify OTP. Please try again.',
      }));
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to verify OTP. Please try again.',
      });
    }
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value;
    setErrorMessages((prevErrors) => ({ ...prevErrors, [field]: '' }));

    if (field === 'userName') {
      setUserName(value);
    } else if (field === 'contactNumber') {
      setContactNumber(value);
    } else if (field === 'otp') {
      setOtp(value);
    } else if (field === 'email') {
      setEmail(value);

    }
  };
  const handleSendOtpClick = async () => {
    try {
      // Ensure the contact number starts with +91
      const formattedContactNumber = contactNumber.startsWith('+91') ? contactNumber : `+91${contactNumber}`;

      // Send the mobile number to the API with the required body format
      const response = await axios.post(process.env.REACT_APP_API_URL_OTP_SEND, {
        data: {
          phone_number: formattedContactNumber,
          has_firebase_check: false,
        },
      });

      if (response.data.success) {
        setShowOtpInput(true);
        setIsOtpVerified(false);
        setOtp('');

        await fetchUserDetails(contactNumber);
      } else {
        // Handle API errors
        Swal.fire({
          icon: 'error',
          title: 'Failed to Send OTP',
          text: response.data.message || 'Something went wrong. Please try again.',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to send OTP. Please try again.',
      });
    }
  };

  function formatDate(date) {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = new Date(date).toLocaleDateString('en-US', options);
    return formattedDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$02-$01-$03');
  }
  const calculateDaysDifference = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const timeDifference = end - start;
    const daysDifference = timeDifference / (1000 * 3600 * 24);
    return Math.abs(Math.floor(daysDifference));
  };



  const handleTrialTimeChange = (time, batchId, status, courtId) => {
    if (status === 'Available') {
      setSelectedTrialTime(time);
      setSelectedCourtId(courtId);
      setErrorMessages((prevErrors) => ({ ...prevErrors, selectedTrialTime: '' }));
    }
  };
  const filteredCenters = selectedArea ? areas.find(area => area.name === selectedArea)?.centers || [] : [];

  const sortedCenters = filteredCenters.map(center => {
    const centerData = centers.find(c => c.id === center.id);
    return centerData ? { ...centerData, km: center.km } : null;
  }).filter(center => center !== null).sort((a, b) => a.km - b.km);


  const isContactNumberValid = /^[0-9]{10}$/.test(contactNumber);
  const ConfirmationModal = ({ showModal, onClose, onConfirm, bookingData, selectedCourtId, selectedCourtTimingId }) => {
    if (!showModal) return null;

    const handleConfirm = async () => {
      try {
        let parentIdToSend = null;
        let childIdToSend = null;

        if (newChildName) {
          // If a new child is being added, set parent ID to the parent's ID and child ID to null
          parentIdToSend = userDetails?.parent?.id || null;
          childIdToSend = null;
        } else if (selectedChildId) {
          // If a specific child is selected, set parent ID to the parent's ID and child ID to the selected child's ID
          parentIdToSend = userDetails?.parent?.id || null;
          childIdToSend = selectedChildId;
        } else if (userDetails && !selectedChildId) {
          // If no child is selected and userDetails is present, assume the parent is selecting itself
          parentIdToSend = userDetails?.parent?.id || null;
          childIdToSend = userDetails?.parent?.id || null; // Set child ID to parent ID
        } else {
          // Default case, set both IDs to null
          parentIdToSend = null;
          childIdToSend = null;
        }

    

        // Find the selected center's academy_id
        const selectedCenterData = centers.find(
          (center) => center.name === bookingData.selectedCenter
        );
        const academyIdToSend = selectedCenterData ? selectedCenterData.id : null;

        // Format mobile number
        const formattedMobileNumber = bookingData.contactNumber.startsWith('+91')
          ? bookingData.contactNumber
          : '+91' + bookingData.contactNumber;
        const formattedProficiencyLevel = proficiencyLevel.toUpperCase();

        // Format start_time and end_time to "HH:MM:SS"
        const [startTime, endTime] = bookingData.selectedTrialTime.split(" - ");
        const formattedStartTime = `${startTime}:00`; // Append ":00" for seconds
        const formattedEndTime = `${endTime}:00`;
        // Prepare the booking data
        const bookingDataForPurchase = {
          parent_id: parentIdToSend,
          user_id: childIdToSend, // child_id is sent as user_id
          name: bookingData.userName,
          email: email,
          mobile_number: formattedMobileNumber,
          gender_type: "Male", // Default or from form input
          academy_id: academyIdToSend, // Fetched from selected center
          court_id: selectedCourtId, // Use the selected batch_id
          sport_id: 11, // Default sport_id
          academy_id: academyIdToSend,
          start_time: formattedStartTime, // Formatted start time
          end_time: formattedEndTime,
          booking_date: formatDateToYYYYMMDD(bookingData.selectedTrialDate),
          // court_timing_id: selectedCourtTimingId,
          proficiency: formattedProficiencyLevel,
          area: selectedArea,
        };



        // Make the API call
        const createOrder = await axios.post(
          process.env.REACT_APP_API_URL_PLAY_TRIAL,
          bookingDataForPurchase,
          {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': process.env.REACT_APP_API_KEY,
            }
          }
        );

        // Handle success
        if (
          createOrder.data.result.bookCourt.success &&
          createOrder.data.result.trialLogs.success
        ) {
          window.location.href = '/SuccessPage';

          // Optional: Store the payment success state in localStorage or sessionStorage
          sessionStorage.setItem('paymentStatus', 'success');
          sessionStorage.setItem('message', 'Your trial has been successfully booked.');

          onClose();
          setContactNumber('');
          setIsOtpVerified(false);
          setOtp('');
          setShowOtpInput(false);
        } else {
          throw new Error(
            createOrder.data.message || 'Failed to process the booking'
          );
        }
      } catch (error) {
        console.error('Error during confirmation:', error);

        let errorMessage = 'Failed to process the booking';

        // Check if error response exists and extract the message
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message || JSON.stringify(error.response.data);
        } else if (error.message) {
          errorMessage = error.message;
        }

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
        });
      }
    };
    const formatDateToYYYYMMDD = (dateString) => {
      const [day, month, year] = dateString.split('-');

      const date = new Date(`${year}-${month}-${day}`);
      if (isNaN(date.getTime())) {
        console.error("Invalid date string:", dateString);
        return "Invalid Date";
      }

      const formattedYear = date.getFullYear();
      const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
      const formattedDay = String(date.getDate()).padStart(2, '0');

      return `${formattedYear}-${formattedMonth}-${formattedDay}`;
    };

    return (
      <div className="confirmation-modal-overlay">
        <div className="modal-content">
          <button className="close-btn" onClick={onClose}>
            <span className="close-icon">&times;</span>
          </button>

          <h3 className="modal-title">Confirm Your Trial</h3>
          <div className="booking-summary">
            <p><strong>Name:</strong> {bookingData.userName}</p>
            <p><strong>Contact Number:</strong> {bookingData.contactNumber}</p>
            <p><strong>Area:</strong> {bookingData.selectedArea}</p>
            <p><strong>Center:</strong> {bookingData.selectedCenter}</p>
            <p><strong>Trial Date:</strong> {bookingData.selectedTrialDate}</p>
            <p><strong>Time Slot:</strong> {bookingData.selectedTrialTime}</p>
          </div>

          <div className="modal-actions">
            <button onClick={handleConfirm} className="btn-confirm">Submit</button>
          </div>
        </div>
      </div>
    );
  };

  const showBackendError = (error) => {
    let errorMessage = 'Something went wrong. Please try again.';

    // Extract error message from backend response
    if (error.response && error.response.data && error.response.data.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }

    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: errorMessage,
    });
  };

  const handleDateChange = (date) => {
    setSelectedTrialDate(date);
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedTrialDate: '',
    }));
  };
  useEffect(() => {
    if (selectedTrialDate && selectedCenter) {
      fetchAvailableSlots();
    }
  }, [selectedTrialDate, selectedCenter]);

  const fetchAvailableSlots = async () => {
    try {
      const selectedCenterData = centers.find(center => center.name === selectedCenter);
      if (!selectedCenterData) {
        throw new Error('Selected center not found.');
      }

      function formatDateToYYYYMMDD(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`; // Use dashes
      }

      // Example usage:

      const formattedDate = formatDateToYYYYMMDD(selectedTrialDate);

      const payload = {
        venueId: selectedCenterData.id,
          // venueId:84,
        sportId: 11,
        date: formattedDate,
        // date: "2025-03-30"
      };

      const response = await axios.post(
        process.env.REACT_APP_API_URL_SLOT_CHECK,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': process.env.REACT_APP_API_KEY,
          }
        }
      );

      if (response.data.message === 'Successfully sent to external API') {

        const courtSlots = response.data.externalResponse.data || [];
    
        // Transform the data into the format expected by the UI
        const processedSlots = courtSlots.flatMap(court => 
          court.slots.map(slot => ({
            court_id: court.courtId,
            open_time: slot.startTime,
            close_time: slot.endTime,
            status: slot.available ? 'Available' : 'Booked',
            available: slot.available,
            ticketsAvailable: slot.ticketsAvailable || 0
          }))
        );

        setAvailableSlots(processedSlots);
      } else {
        throw new Error('Failed to fetch available slots.');
      }
    } catch (error) {
      console.error('Error fetching available slots:', error);
      showBackendError(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Failed to fetch available slots.',
      });
    }
  };
  const formatDateToYYYYMMDD = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}:${month}:${day}`;
  };
  useEffect(() => {
    setSelectedTrialTime(null); // ✅ Reset timeslot when date updates
  }, [selectedTrialDate]);
  const [searchQuery, setSearchQuery] = useState('');
  return (
    <div className="enroll-trial-container">
      <h2 className="rescedule-title">
        Book Trial
      </h2>
      <form className="booking-form" onSubmit={handleSubmit}>

        <div className="floating-select" ref={selectWrapperRef}>
          <div
            className={`sales-filter-academy ${selectedArea ? 'has-value' : ''}`}
            onClick={() => setShowAreaDropdown(true)} // Only open, don't toggle
          >
            <div className="selected-option">
              {selectedArea || 'Select an Area'}
            </div>
            <div
              className={`custom-dropdown ${showAreaDropdown ? 'open' : ''}`}
              ref={areaDropdownRef}
              onClick={(e) => e.stopPropagation()} // Prevent closing when interacting with search
            >
              {showAreaDropdown && (
                <input
                  type="text"
                  placeholder="Search area..."
                  className="search-input"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onClick={(e) => e.stopPropagation()} // Ensure input box doesn’t close dropdown
                />
              )}
              {areas
                .filter((area) => area.name.toLowerCase().includes(searchQuery.toLowerCase()))
                .map((area, index) => (
                  <div
                    key={index}
                    className="custom-option"
                    onClick={() => {
                      handleAreaChange(area.name);
                      setShowAreaDropdown(false); // Close dropdown after selection
                    }}
                  >
                    {area.name}
                  </div>
                ))}
            </div>
          </div>
          {selectedArea && <label htmlFor="selectedArea">Area</label>}
          {errorMessages.selectedArea && <p className="error">{errorMessages.selectedArea}</p>}
        </div>

        {selectedArea && (
          <div className="floating-select" ref={selectWrapperRef}>
            <div
              className={`sales-filter-academy ${selectedCenter ? 'has-value' : ''}`}
              onClick={() => setShowCenterDropdown(!showCenterDropdown)}
            >
              <div className="selected-option">
                {selectedCenter || 'Select Center'}
              </div>
              <div
                className={`custom-dropdown ${showCenterDropdown ? 'open' : ''}`}
                ref={centerDropdownRef}
              >
                {sortedCenters.map((center) => (
                  <div
                    key={center.id}
                    className="custom-option"
                    onClick={() => handleCenterChange(center.name)}
                  >
                    {center.name}
                  </div>
                ))}
              </div>
            </div>
            {selectedCenter && <label htmlFor="selectedCenter">Center</label>}
            {errorMessages.selectedCenter && <p className="error">{errorMessages.selectedCenter}</p>}
          </div>
        )}

        {selectedCenter && (
          <div className="trial-time-picker">
            <label className="trial-time-label">Proficiency Level:</label>
            <div className="trial-time-options">
              <button
                type="button"
                className={`trial-time-option ${proficiencyLevel === 'Basic' ? 'selected' : ''}`}
                onClick={() => handleProficiencyChange('Basic')}
              >
                Beginner
              </button>
              <button
                type="button"
                className={`trial-time-option ${proficiencyLevel === 'Intermediate' ? 'selected' : ''}`}
                onClick={() => handleProficiencyChange('Intermediate')}
              >
                Intermediate
              </button>
              <button
                type="button"
                className={`trial-time-option ${proficiencyLevel === 'Advanced' ? 'selected' : ''}`}
                onClick={() => handleProficiencyChange('Advanced')}
              >
                Advance
              </button>
            </div>
            {errorMessages.proficiencyLevel && <p className="error">{errorMessages.proficiencyLevel}</p>}
          </div>
        )}

        {selectedCenter && (
          <div><label className="form-date">Trial Date:</label></div>
        )}

        {selectedCenter && (
          <div className="floating-select">
            <DatePicker
              className={`sales-filter-academy ${selectedTrialDate ? 'has-value' : ''}`}
              selected={selectedTrialDate}
              onChange={handleDateChange}
              minDate={new Date()}
              dateFormat="dd/MM/yyyy"
              placeholderText="Select trial date"
              required
              inline
            />
            {errorMessages.selectedTrialDate && (
              <p className="error">{errorMessages.selectedTrialDate}</p>
            )}
          </div>
        )}

{selectedTrialDate && (
  <div className="trial-time-picker">
    <label className="trial-time-label">Time Slot:</label>
    <div className="trial-time-options">
      {availableSlots.length > 0 ? (
        availableSlots.map((slot, index) => {
          const startTime = slot.open_time ? slot.open_time.slice(0, 5) : 'N/A';
          const endTime = slot.close_time ? slot.close_time.slice(0, 5) : 'N/A';
          const isAvailable = slot.status === 'Available';

          return (
            <button
              type='button'
              key={index}
              className={`trial-time-option ${selectedTrialTime === `${startTime} - ${endTime}` ? 'selected' : ''
                } ${!isAvailable ? 'disabled' : ''}`}
              onClick={() =>
                handleTrialTimeChange(
                  `${startTime} - ${endTime}`,
                  null, // batchId - pass null if not used
                  slot.status,
                  slot.court_id,
                )
              }
              disabled={!isAvailable}
            >
              <div>
                {startTime} - {endTime}
              </div>
              <div>
                {slot.status} 
                {slot.ticketsAvailable > 0 && ` (${slot.ticketsAvailable} left)`}
              </div>
            </button>
          );
        })
      ) : (
        <p className="no-time-slot">No Time Slots Available</p>
      )}
    </div>
    {errorMessages.selectedTrialTime && (
      <p className="error">{errorMessages.selectedTrialTime}</p>
    )}
  </div>
)}

        <div className="floating-select">
          <input
            className={`sales-filter-academy ${contactNumber ? 'has-value' : ''}`}
            type="tel"
            value={contactNumber}
            onChange={(e) => handleInputChange(e, 'contactNumber')}
            onKeyPress={(e) => {
              if (!/^[0-9]$/.test(e.key)) {
                e.preventDefault();
              }
            }}
            maxLength={10}
            placeholder="Enter 10-digit phone number"
          />

          {contactNumber && <label htmlFor="contactNumber">Contact Number</label>}
          {errorMessages.contactNumber && <p className="error">{errorMessages.contactNumber}</p>}
          {errorMessages.otp && <p className="error">{errorMessages.otp}</p>}
          {isOtpVerified && (
            <span className="checkmark">✓</span>
          )}

          {!showOtpInput && !isOtpVerified && isContactNumberValid && (
            <button type="button" onClick={handleSendOtpClick} className="btn-send-otp">
              Send OTP
            </button>
          )}
        </div>

        {showOtpInput && !isOtpVerified && (
          <div className="floating-select">
            <input
              className={`sales-filter-academy ${otp ? 'has-value' : ''}`}
              type="text"
              value={otp}
              onChange={(e) => handleInputChange(e, 'otp')}
              maxLength={6}
              placeholder="Enter OTP"
            />
            <button type="button" onClick={handleOtpVerification} className="btn-send-otp">
              Verify OTP
            </button>
          </div>
        )}

        {isNewUser && isOtpVerified && (
          <div className="floating-select">
            <input
              className={`sales-filter-academy ${userName ? 'has-value' : ''}`}
              type="text"
              value={userName}
              onChange={(e) => handleInputChange(e, 'userName')}
              placeholder="Enter your name"
            />
            {userName && <label htmlFor="userName">Name</label>}
            {errorMessages.userName && <p className="error">{errorMessages.userName}</p>}
          </div>
        )}

        {isOtpVerified && userDetails && (
          <div className="floating-select-child" ref={selectWrapperRef}>
            <label htmlFor="child" className="selectchild">User Name</label>

            <div
              className={`sales-filter-academy ${userName ? 'has-value' : ''}`}
              contentEditable
              suppressContentEditableWarning
              onBlur={(e) => {
                const newName = e.target.textContent;
                // Update both userDetails and userName state
                setUserDetails(prev => ({
                  ...prev,
                  parent: { ...prev.parent, name: newName }
                }));
                setUserName(newName); // 🔄 Update the userName state with edited value
              }}
            >
              {/* Display current userName instead of API name */}
              {userName || userDetails.parent.name}
            </div>

            {errorMessages.child && <p className="error">{errorMessages.child}</p>}
          </div>
        )}
        {isOtpVerified && (
          <div className="floating-select">
            <input
              className={`sales-filter-academy ${email ? 'has-value' : ''}`}
              type="email"
              value={email}
              onChange={(e) => handleInputChange(e, 'email')}
              placeholder="Enter your email"
            />
            {email && <label htmlFor="email">Email</label>}
            {errorMessages.email && <p className="error">{errorMessages.email}</p>}
          </div>
        )}

        <div className="form-group">
          <button className="form-button" type="submit">Proceed</button>

        </div>

        <ConfirmationModal
          showModal={showConfirmationModal}
          onClose={() => setShowConfirmationModal(false)}
          selectedCourtTimingId={selectedCourtTimingId}
          selectedCourtId={selectedCourtId}
          onConfirm={() => {
            alert('Booking Confirmed!');
            setShowConfirmationModal(false);

          }}
          bookingData={formData}
        />
      </form>
    </div>
  );
};

export default BookTrial;